import React, { useEffect } from 'react'
import { Controller } from 'react-hook-form';
import Select from 'react-select';
import { useCountries } from '../../../../services/common/hooks/useCountries';

interface CountrySelectOptionComponentProps {
    control: any;
    errors: any;
}

interface CountryOption {
    value: string;
    label: string;
}

const CountrySelectOptionComponent: React.FC<CountrySelectOptionComponentProps> = ({ control, errors }) => {
    const [countryOptions, setCountryOptions] = React.useState<CountryOption[]>([]);
    const { data: countries, isFetching, isError } = useCountries();

    useEffect(() => {
        if (countries) {
            const formattedCountries = countries.data.map((country) => ({
                value: country.value,
                label: country.text,
            }));
            setCountryOptions(formattedCountries);
        }
    }, [countries]);

    return (
        <div className="col-sm-4">
            <label htmlFor="country" className="col-sm-4 col-form-label d-flex" style={{ fontSize: '14px' }}>Country:</label>
            <Controller
                name="customer_country"
                control={control}
                render={({ field }) => (
                    <Select
                        {...field}
                        options={countryOptions}
                        onChange={(selected) => {
                            if (selected) {
                                field.onChange(selected.value);
                            }
                        }}
                        isDisabled={isFetching || isError}
                        isLoading={isFetching}
                        placeholder="Select Country"
                        value={countryOptions.find((option) => option.value === field.value)}
                    />
                )}
            />
            {errors.customer_country && <span className="text-danger">{errors.customer_country.message}</span>}
        </div>
    )
}

export default CountrySelectOptionComponent